import { render, staticRenderFns } from "./editFullFift.vue?vue&type=template&id=6de5ab8e&scoped=true&"
import script from "./editFullFift.vue?vue&type=script&lang=js&"
export * from "./editFullFift.vue?vue&type=script&lang=js&"
import style0 from "./editFullFift.vue?vue&type=style&index=0&id=6de5ab8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5ab8e",
  null
  
)

export default component.exports